import React from 'react';
import { Users, Info } from 'lucide-react';
import { stripePricingTable } from '../../data/mock';
import useExternalScript from '../../hooks/useExternalScript';

export default function PricingTableSection() {
  useExternalScript('https://js.stripe.com/v3/pricing-table.js');
  return (
    <section id="pricing" className="py-20 scroll-mt-24" data-testid="pricing-table-section">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-8">
          <div className="uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">Ages 3 – 12 &middot; Group Membership</div>
          <h2 className="font-display font-bold text-4xl md:text-5xl text-splash-green leading-tight">Choose your monthly membership</h2>
        </div>
        <div className="grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto mb-10">
          <div data-testid="pricing-subscription-note" className="rounded-2xl bg-white border border-splash-sand p-4 flex gap-3 text-sm text-splash-green/85">
            <Info className="w-5 h-5 text-splash-teal shrink-0" />
            <span><strong className="text-splash-green">A subscription is required for each child.</strong> Enrolling two swimmers? Complete checkout once per child.</span>
          </div>
          <div data-testid="pricing-sibling-note" className="rounded-2xl bg-white border border-splash-sand p-4 flex gap-3 text-sm text-splash-green/85">
            <Users className="w-5 h-5 text-splash-coral shrink-0" />
            <span><strong className="text-splash-green">$20 sibling discount</strong> is applied by our team after enrollment for each additional child.</span>
          </div>
        </div>
        <div className="rounded-3xl bg-white border border-splash-sand p-2 md:p-6 overflow-hidden" data-testid="stripe-pricing-table">
          <stripe-pricing-table
            pricing-table-id={stripePricingTable.id}
            publishable-key={stripePricingTable.publishableKey}
          />
        </div>
      </div>
    </section>
  );
}
